module.exports = {
  platform: 'voice',
  name: 'Transfer',
  node: 'transfer',
  bg: '#FFFFFF',
  note: '',
  property: {
    type: 'flow_ui_id',
    flow_ui_id: '',
    flow_ui_name: '',
    contact_id: '',
    contact_name: '',
    number: '',
    number_name: '',
    queue_id: '',
    queue_name: '',
    use_append_to_number: false,
    use_integration_detail: false,
    use_sip_header: false,
    integration_detail_key: '',
    integration_detail_value: '',
    integration_detail_sip_header: '',
    integration_detail_append_to_number: '',
    vxml: ''
  }
}
